// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NgxLoggerLevel } from "ngx-logger";

export const env = {
	production: false,
	// more info on locales in README
	availableLocales: ['en'],
	//backendBaseURL: 'http://klar-result.hu:33/api',
	//beURL: '/api',
	beURL: 'https://b.n-whale.com/a',
	assetBaseURL: 'assets',
	priceSchedulerFreqSecs: 60,
	logLevel: NgxLoggerLevel.TRACE,

	/* useful PayPal related links:
		 https://github.com/paypal/paypal-checkout/blob/master/docs/button.md
		 https://developer.paypal.com/docs/checkout/how-to/customize-button/
	*/
  payPal: {
			env: 'sandbox',
			commit: true,
			style: {
			label: 'paypal',
		size: 'responsive',
		shape: 'pill',
		color: 'blue',
		tagline: false
	 }
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
